import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Phone(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.contactInformation.phone.label}>
      {extOrder.orderStep.phone ?? <preview.NullValue />}
    </preview.Field>
  )
}
